import TailwindButton from "components/general/tailwindButton";

const Card = () => {
  return (
    <div className="flex w-full items-end justify-center sm:mt-20">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-10">
        {/* Black Card */}
        <div className="flex flex-col justify-center w-[90%] sm:w-[580px] h-[473px] text-start ml-5">
          <h1 className="text-3xl sm:text-5xl">Redact Enterprise</h1>
          <p className="text-slate-300">
            Looking for an automated way to audit, monitor, and manage your company&apos;s social
            media accounts? Redact Enterprise software manages your company&apos;s online risk,
            across all major social platforms. Take control of your organizations privacy today.
          </p>
          <div className="grid sm:grid-cols-8 gap-0">
            <div className="col-span-2">
              <p className="text-slate-300">
                Trusted by <br /> 100+ companies
              </p>
            </div>

            <div className="sm:flex hidden w-full items-end justify-center">
              <div className="bg-brand-slate/40 w-[1px] h-[30px] self-center"></div>
            </div>

            <div className="col-span-2">
              <p className="text-slate-300">App rating</p>
              <div className="flex flex-row -mt-3">
                <span
                  className="icon-[bxs--star]"
                  style={{ width: "1.2rem", height: "1.2rem" }}
                ></span>
                <span
                  className="icon-[bxs--star]"
                  style={{ width: "1.2rem", height: "1.2rem" }}
                ></span>
                <span
                  className="icon-[bxs--star]"
                  style={{ width: "1.2rem", height: "1.2rem" }}
                ></span>
                <span
                  className="icon-[bxs--star]"
                  style={{ width: "1.2rem", height: "1.2rem" }}
                ></span>
                <span
                  className="icon-[bxs--star-half]"
                  style={{ width: "1.2rem", height: "1.2rem" }}
                ></span>
                <p className="mt-0 ml-2 text-slate-300">4.5</p>
              </div>
            </div>

            <div className="sm:flex hidden w-full items-end justify-center">
              <div className="bg-brand-slate/40 w-[1px] h-[30px] self-center"></div>
            </div>

            <div className="col-span-2">
              <p className="text-slate-300">Made in</p>
              <div className="flex flex-row -mt-4">
                <span
                  className="icon-[openmoji--flag-us-outlying-islands] -mt-0.5"
                  style={{ width: "1.8rem", height: "1.8rem" }}
                ></span>
                <p className="mt-0 ml-2 text-slate-300">USA</p>
              </div>
            </div>
          </div>
        </div>
        {/* Slate card */}
        <div className="flex w-[90%] ml-5 sm:ml-0 sm:w-[580px] bg-brand-slate rounded-lg">
          <div className="flex flex-col h-[500px]  sm:w-[539px] sm:h-[336px] ml-5 mt-5">
            <div className="flex flex-row items-center justify-start mt-0">
              <span
                className="icon-[ic--sharp-check]"
                style={{ width: "1rem", height: "1rem", color: "#7551CB" }}
              ></span>
              <p className="ml-2">
                Privacy professionals at Redact tailor our features for your needs
              </p>
            </div>
            <div className="flex flex-row items-center justify-start -mt-3">
              <span
                className="icon-[ic--sharp-check]"
                style={{ width: "1rem", height: "1rem", color: "#7551CB" }}
              ></span>
              <p className="ml-2">Advanced copyright protection</p>
            </div>
            <div className="flex flex-row items-center justify-start -mt-3">
              <span
                className="icon-[ic--sharp-check]"
                style={{ width: "1rem", height: "1rem", color: "#7551CB" }}
              ></span>
              <p className="ml-2">
                Seat Manager, easily managing tens or even hundreds of account in one place
              </p>
            </div>
            <div className="flex flex-row items-center justify-start -mt-3">
              <span
                className="icon-[ic--sharp-check]"
                style={{ width: "1rem", height: "1rem", color: "#7551CB" }}
              ></span>
              <p className="ml-2">1:1 business support 24/7 monitoring</p>
            </div>
            <div className="flex flex-row items-center justify-start -mt-3">
              <span
                className="icon-[ic--sharp-check]"
                style={{ width: "1rem", height: "1rem", color: "#7551CB" }}
              ></span>
              <p className="ml-2">
                Advanced archiving tools, ensuring your meeting data retention policies
              </p>
            </div>
            <div className="flex flex-row items-center justify-start -mt-3">
              <span
                className="icon-[ic--sharp-check]"
                style={{ width: "1rem", height: "1rem", color: "#7551CB" }}
              ></span>
              <p className="ml-2">
                Powerful scheduler feature, to enforce time limits for how long post are live
              </p>
            </div>
            <div className="flex flex-row items-center justify-start -mt-3">
              <span
                className="icon-[ic--sharp-check]"
                style={{ width: "1rem", height: "1rem", color: "#7551CB" }}
              ></span>
              <p className="ml-2">Enjoy an expanded supported services, including Instagram</p>
            </div>
            <div className="flex flex-row items-center justify-start mt-5 space-x-8">
              <TailwindButton
                buttonBGColor="bg-transparent"
                buttonHeight="h-[45px]"
                buttonWidth="w-[136px]"
                buttonBorderColor="border-white"
                buttonText="Book a demo"
                buttonURL="https://calendly.com/noah-redactpro"
                buttonTextTailwindStyle="font-bold"
              />
              <TailwindButton
                buttonBGColor="bg-[#7551CB]"
                buttonBorderColor="border-[#422686]"
                buttonHeight="h-[45px]"
                buttonWidth="w-[136px]"
                buttonText="Contact sales"
                buttonURL="/contact-expert"
                buttonTextTailwindStyle="font-bold"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Card;
